function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0.00201416C5.37321 0.00201416 0 5.37523 0 12.002C0 18.6288 5.37321 24.002 12 24.002C18.6268 24.002 24 18.6288 24 12.002C24 5.37523 18.6268 0.00201416 12 0.00201416ZM12 21.9663C6.49821 21.9663 2.03571 17.5038 2.03571 12.002C2.03571 6.50023 6.49821 2.03773 12 2.03773C17.5018 2.03773 21.9643 6.50023 21.9643 12.002C21.9643 17.5038 17.5018 21.9663 12 21.9663Z",
  fill: "#C08807"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7139 16.7163C10.7139 17.0573 10.8493 17.3843 11.0904 17.6254C11.3316 17.8666 11.6586 18.002 11.9996 18.002C12.3406 18.002 12.6676 17.8666 12.9087 17.6254C13.1498 17.3843 13.2853 17.0573 13.2853 16.7163C13.2853 16.3753 13.1498 16.0483 12.9087 15.8072C12.6676 15.566 12.3406 15.4306 11.9996 15.4306C11.6586 15.4306 11.3316 15.566 11.0904 15.8072C10.8493 16.0483 10.7139 16.3753 10.7139 16.7163ZM11.3567 13.7163H12.6424C12.7603 13.7163 12.8567 13.6199 12.8567 13.502V6.2163C12.8567 6.09844 12.7603 6.00201 12.6424 6.00201H11.3567C11.2389 6.00201 11.1424 6.09844 11.1424 6.2163V13.502C11.1424 13.6199 11.2389 13.7163 11.3567 13.7163Z",
  fill: "#C08807"
});

const SvgInfoIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-icon.f27102c6.svg";
export { ForwardRef as ReactComponent };